const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 17.5,
  y: 30,
  width: 15,
  height: 40,
  fill: "#d06062"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "y",
  repeatCount: "indefinite",
  dur: "1s",
  calcMode: "spline",
  keyTimes: "0;0.5;1",
  values: "18;30;30",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "-0.2s"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "height",
  repeatCount: "indefinite",
  dur: "1s",
  calcMode: "spline",
  keyTimes: "0;0.5;1",
  values: "64;40;40",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "-0.2s"
}));
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 42.5,
  y: 30,
  width: 15,
  height: 40,
  fill: "#f5e1a0"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "y",
  repeatCount: "indefinite",
  dur: "1s",
  calcMode: "spline",
  keyTimes: "0;0.5;1",
  values: "20.999999999999996;30;30",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "-0.1s"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "height",
  repeatCount: "indefinite",
  dur: "1s",
  calcMode: "spline",
  keyTimes: "0;0.5;1",
  values: "58.00000000000001;40;40",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "-0.1s"
}));
var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 67.5,
  y: 30,
  width: 15,
  height: 40,
  fill: "#cee5cb"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "y",
  repeatCount: "indefinite",
  dur: "1s",
  calcMode: "spline",
  keyTimes: "0;0.5;1",
  values: "20.999999999999996;30;30",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "height",
  repeatCount: "indefinite",
  dur: "1s",
  calcMode: "spline",
  keyTimes: "0;0.5;1",
  values: "58.00000000000001;40;40",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1"
}));
function SvgLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "transparent",
      display: "block",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.8e5aaedf3a646a161866665361b9d38f.svg";
export { ForwardRef as ReactComponent };